// DataTrace Product Configurations
// Centralized configuration for all DataTrace API products and endpoints

// Base URL options
export const BASE_URL_OPTIONS = [
  {
    name: 'UAT Gateway (Recommended)',
    url: 'https://uat.gateway.datatracetitle.com/ddg',
    description: 'UAT API Gateway - supports all products (TIQSA, Tax, Property Data)'
  }
];

// Available product configurations
export const PRODUCT_CONFIGS = [
  {
    name: 'Property Data - Property Detail (Recommended)',
    baseUrl: 'https://uat.gateway.datatracetitle.com/ddg',
    productCode: 'property_data',
    productType: 'property_detail',
    endpoint: 'property_data_sync',
    description: 'Get property details including APN, ownership, and legal description'
  },
  {
    name: 'Property Data - Instant Recordable Legal',
    baseUrl: 'https://uat.gateway.datatracetitle.com/ddg',
    productCode: 'property_data',
    productType: 'instant_recordable_legal',
    endpoint: 'property_data_sync',
    description: 'Get ownership, legal description, and recorded documents'
  },
  {
    name: 'TIQSA - Current Owner Bronze (Title Search)',
    baseUrl: 'https://uat.gateway.datatracetitle.com/ddg',
    productCode: 'tiqsa',
    productType: 'current_owner_bronze',
    endpoint: 'tiqsa',
    description: 'Title search with current owner information (TIQSA product) - Requires parties field'
  },
  {
    name: 'TIQSA - Current Owner Silver (Title Search + Data)',
    baseUrl: 'https://uat.gateway.datatracetitle.com/ddg',
    productCode: 'tiqsa',
    productType: 'current_owner_silver',
    endpoint: 'tiqsa',
    description: 'Title search with docs and data payload - Requires parties field'
  },
  {
    name: 'Tax Data',
    baseUrl: 'https://uat.gateway.datatracetitle.com/ddg',
    productCode: 'tax',
    productType: 'taxsource',
    endpoint: 'tax',
    description: 'Get tax information, assessments, and payment status'
  },
  {
    name: 'Custom Configuration',
    baseUrl: '',
    productCode: 'custom',
    productType: 'custom',
    endpoint: 'custom',
    description: 'Enter your own base URL, product code, type, and endpoint'
  }
];

// State and county options for property searches
export const STATES = [
  { code: 'MI', name: 'Michigan' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'FL', name: 'Florida' },
  { code: 'NV', name: 'Nevada' },
  { code: 'OR', name: 'Oregon' },
  { code: 'TX', name: 'Texas' },
  { code: 'WA', name: 'Washington' }
];

export const COUNTY_OPTIONS = {
  MI: ['Kent', 'Ottawa', 'Allegan', 'Barry', 'Ionia', 'Montcalm', 'Muskegon', 'Newaygo',
       'Genesee', 'Ingham', 'Kalamazoo', 'Macomb', 'Oakland', 'Washtenaw', 'Wayne'],
  CA: ['Los Angeles', 'Orange', 'San Diego', 'Riverside', 'San Bernardino', 'Santa Clara', 'Alameda', 'Sacramento'],
  TX: ['Harris', 'Dallas', 'Tarrant', 'Bexar', 'Travis', 'Collin'],
  FL: ['Miami-Dade', 'Broward', 'Palm Beach', 'Hillsborough', 'Orange'],
  AZ: ['Maricopa', 'Pima', 'Pinal', 'Yavapai'],
  NV: ['Clark', 'Washoe', 'Carson City'],
  CO: ['Denver', 'El Paso', 'Arapahoe', 'Jefferson', 'Adams'],
  WA: ['King', 'Pierce', 'Snohomish', 'Spokane', 'Clark'],
  OR: ['Multnomah', 'Washington', 'Clackamas', 'Lane', 'Marion']
};

// Helper to find product config
export const findProductConfig = (baseUrl, productCode, productType) => {
  return PRODUCT_CONFIGS.find(c =>
    c.baseUrl === baseUrl &&
    c.productCode === productCode &&
    c.productType === productType
  );
};

// Helper to get config key for comparison
export const getConfigKey = (config) => {
  return `${config.baseUrl}:${config.productCode}:${config.productType}`;
};

export default {
  BASE_URL_OPTIONS,
  PRODUCT_CONFIGS,
  STATES,
  COUNTY_OPTIONS,
  findProductConfig,
  getConfigKey
};
